// ============================================================================
// ตัวช่วยอ่านรูปภาพของข่าว
// รองรับทั้งข้อมูลใหม่ (คอลัมน์ images แบบ array) และข้อมูลเก่า (คอลัมน์ image รูปเดียว)
// ถ้ายังไม่ได้รัน migration เพิ่มคอลัมน์ images ฟังก์ชันนี้จะ fallback ไปใช้ image เดิม
// ============================================================================

/** แปลงค่า images จาก DB ให้เป็น array ของ URL เสมอ */
export const getNewsImages = (news) => {
  if (!news) return [];

  let raw = news.images;

  // supabase คืน jsonb มาเป็น array อยู่แล้ว แต่เผื่อกรณีถูกเก็บเป็น text
  if (typeof raw === 'string') {
    try { raw = JSON.parse(raw); } catch { raw = null; }
  }

  const list = Array.isArray(raw)
    ? raw.filter(url => typeof url === 'string' && url.trim())
    : [];

  if (list.length > 0) return list;

  // ข่าวเก่าที่ยังมีแค่รูปเดียว
  return news.image ? [news.image] : [];
};

/** รูปปกของข่าว (รูปแรกใน array) */
export const getNewsCover = (news) => getNewsImages(news)[0] || '';
